<template>
  <div>
    <div v-if="takeSpot" style="text-align:left; position:relative;">
      <c-spot-card
        :customize="customize"
        :spot="takeSpot"
        :isShowButton="false"
        style="position:absolute; bottom:40px; left:0; width:100%;"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MapTooltipSpot',
  data() {
    return {
      takeSpot: null,
    };
  },
  props: {
    spot: null,
    // サイト ID 毎に設定しているカスタマイズ情報
    customize: {type: Object, required: true},
  },
  watch: {
    spot: 'watchSpot',
  },
  mounted() {
    this.watchSpot(this.spot);
  },
  methods: {
    watchSpot(spot) {
      this.takeSpot = this.spot;
    }
  }
};
</script>

<style scoped>
</style>
